import { Divider, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';

import styles from './copilotMotivation.module.scss';

export const CopilotMotivation = (): JSX.Element => {
  return (
    <FlexBox
      flexDirection="column"
      gap="400"
      className={styles.copilotMotivation}
    >
      <Text.Heading variant="heading-3">Why Agent Co-pilot?</Text.Heading>
      <FlexBox flexDirection="row" gap="300">
        <FlexBox flexDirection="row" gap="300">
          <Icon
            name="arrow-square-up"
            size={24}
            color="#5644D8"
            className={styles.icon}
          />
          <FlexBox flexDirection="column" gap="300">
            <Text.Heading variant="heading-3">Efficiency</Text.Heading>
            <Text.Paragraph>
              Agent Co-pilot boosts agent efficiency with AI-driven tools like
              Smart Replies and Summaries, ensuring swift and precise responses
              to customer queries.
            </Text.Paragraph>
          </FlexBox>
        </FlexBox>
        <Divider orientation="vertical" />
        <FlexBox flexDirection="row" gap="300">
          <Icon
            name="world"
            size={24}
            color="#5644D8"
            className={styles.icon}
          />
          <FlexBox flexDirection="column" gap="300">
            <Text.Heading variant="heading-3">Global Reach</Text.Heading>
            <Text.Paragraph>
              With AI Translations, language barriers are a thing of the past.
              Expand your customer base and provide support in multiple
              languages effortlessly.
            </Text.Paragraph>
          </FlexBox>
        </FlexBox>
        <Divider orientation="vertical" />
        <FlexBox flexDirection="row" gap="300">
          <Icon name="star" size={24} color="#5644D8" className={styles.icon} />
          <FlexBox flexDirection="column" gap="300">
            <Text.Heading variant="heading-3">
              Polished Communication
            </Text.Heading>
            <Text.Paragraph>
              Ensure professional correspondence every time with the AI
              Spellchecker, guaranteeing error-free communication that reflects
              positively on your brand.
            </Text.Paragraph>
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};
